import { loadCookie } from './cookies.ts';

export const hasAmplitudeConsent = (): boolean => {
  const { destinations } = loadCookie('tracking-preferences2') ?? {};
  return Boolean(
    destinations?.Amplitude || destinations?.['Actions Amplitude']
  );
};

export const getAmplitudeSessionId = (): number =>
  Number(loadCookie('analytics_session_id')) || 0;
